import React from 'react';
import { observer } from 'mobx-react';

import { useStores } from 'hooks/useStores';

import { FormCallback } from 'components/form';
import { LkLogin } from 'components/lk/Login/lkLogin';
import { GetGiftFormModal } from 'components/lk/GiftCabinet/components';
import { GetGiftConfirmFormModal } from '../lk/GiftCabinet/components';

import Modal from './components/Modal';
import { MODAL_TYPE } from '../../const/modalType';

const modals = {
  empty: {
    component: () => <div />,
    type: MODAL_TYPE.MODAL_SIDE,
  },
  login: {
    component: LkLogin,
    type: MODAL_TYPE.MODAL_SIDE
  },
  callback: {
    component: FormCallback,
    type: MODAL_TYPE.MODAL_SIDE },
  getGift: {
    component: GetGiftFormModal,
    type: MODAL_TYPE.MODAL_CENTER },
  getGiftConfirm: {
    component: GetGiftConfirmFormModal,
    type: MODAL_TYPE.MODAL_SIDE,
  },
};

export const Modals = observer(() => {
  const { modalStore } = useStores();
  const CurrentModal = modals[modalStore?.currentModal ?? 'empty'].component;
  const currentModalType = modals[modalStore?.currentModal ?? 'empty'].type;

  const isOpen = modalStore?.isOpen();

  return (
    <Modal isOpen={isOpen} type={currentModalType}>
      <CurrentModal handleClose={modalStore.close} />
    </Modal>
  );
});
